import React from 'react';
import { Link, useStaticQuery, graphql } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import './menu.scss';
import { SLIDE_LIST } from '../maps';

import NewContent from '../images/new-content-menu.svg';
import { showNewContentBanner } from './new-content';

const menuItems = SLIDE_LIST.map((slide) => {
  if (!showNewContentBanner()) {
    return {
      ...slide,
      // disable newContent banner after expiration
      newContent: false,
    };
  }

  return slide;
});

const Menu = ({ isOpen, toggleMenu }) => {
  const data = useStaticQuery(graphql`
    {
      allFile(filter: { extension: { eq: "png" }, sourceInstanceName: { eq: "thumbnails" } }) {
        edges {
          node {
            base
            childImageSharp {
              gatsbyImageData(height: 310, width: 550, layout: CONSTRAINED, quality: 90)
            }
          }
        }
      }
    }
  `);

  const getImage = (filename) => {
    const result = data.allFile.edges.find((fileData) => fileData.node.base === filename);
    return result.node.childImageSharp.gatsbyImageData;
  };

  return (
    <div className={`Menu ${isOpen ? 'Menu--open' : ''}`}>
      <div className="container-fluid">
        <ul className="list-unstyled d-flex flex-wrap mt-3">
          {menuItems.map((item) => (
            <li key={item.slug} className="Menu__item p-3">
              <Link
                to={`/presentation/${item.slug}`}
                className="card h-100"
                activeClassName="border-primary text-primary"
                onClick={toggleMenu}
              >
                {item.newContent && <NewContent className="new-content" />}
                <div className="card-body text-center">
                  <GatsbyImage image={getImage(item.download)} alt={item.title} className="img-fluid" />
                  <div className="font-weight-bold text-center">{item.title}</div>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Menu;
